<template>
	<div class="flex-centerize card-container">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'SpaceIconCard',
};
</script>
<style scoped lang="scss">
.card-container {
	width: 22px;
	height: 22px;
	border-radius: 5px;
	background: var(--white);
	border: 2px solid var(--border-color);
}
</style>
